import { IState } from 'Interfaces/state';
import { createSelector } from 'reselect';
import {picdata} from 'Interfaces/picdata';

export const selectHome = (state: IState) => state.get('home');

export const makeSelectPicdata = () => createSelector(
  selectHome,
  (homeState) => homeState.get('picdata') as picdata[]
);



// WEBPACK FOOTER //
// ./src/containers/HomePage/selectors.ts